import React from 'react'
import PropTypes from 'prop-types'
import notify from 'utils/notification'

export default class ManagedUsersList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedUser: {},
      searchTerm: ''
    }

    this.search = this.search.bind(this)
    this.selectedUser = this.selectUser.bind(this)
    this.handleRemoveClick = this.handleRemoveClick.bind(this)
  }

  search (searchTerm) {
    this.setState({
      searchTerm: searchTerm.toLowerCase()
    })
  }

  selectUser (selectedUser) {
    this.setState({
      selectedUser
    })
  }

  handleRemoveClick () {
    if (!this.state.selectedUser.id) {
      notify.warning({
        message: 'Select a user to remove'
      })
      return
    }

    this.props.removeManagedUser(this.state.selectedUser.id)
    this.setState({
      selectedUser: {}
    })
  }

  get filteredUsers () {
    if (!this.state.searchTerm) return this.props.users
    return this.props.users.filter(user => user.screenName.toLowerCase().includes(this.state.searchTerm))
  }

  render () {
    const {
      count,
      className,
      emptyMessage
    } = this.props

    const {
      selectedUser
    } = this.state

    const { id: selectedUserId } = selectedUser

    if (!count) {
      return <div className={`form-group margin-top-10 ${className}`}>
        <label>{emptyMessage}</label>
      </div>
    }

    return (
      <div className={`form-group margin-top-10 ${className}`}>
        <label>Users ({count}):</label>
        <div className='input-group'>
          <input
            type='text'
            className='form-control'
            placeholder='Search'
            onChange={(e) => this.search(e.target.value)}
          />
          <span className='input-group-btn'>
            <button className='btn red'>
              <i className='fa fa-search' />
            </button>
          </span>
        </div>
        <table className='table table-hover table-stripe'>
          <tbody style={{ border: '1px solid #eee' }}>
            {this.filteredUsers.map(user => (
              <tr
                key={user.id}
                onClick={() => this.selectUser(user)}
                className={user.id === selectedUserId ? 'selectedRow' : ''}
                style={{ cursor: 'pointer' }}
              >
                <td style={{ width: 30 }} className='text-left'>
                  {user.id === selectedUserId ? (
                    <i className='fa fa-check' />
                  ) : null}
                </td>

                <td className='text-left' key={user.id}>
                  {user.screenName}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <a onClick={this.handleRemoveClick} style={{ color: '#AA1616', fontWeight: 400 }}>
          Remove selected user
        </a>
      </div>
    )
  }
}

ManagedUsersList.propTypes = {
  users: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  emptyMessage: PropTypes.string,
  className: PropTypes.string,
  removeManagedUser: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/user-permissions/managed-users-list.js